<template>
  <div class="login-bg">
    <div class="login_content-wrapper">
      <div class="login_logo">
        <img
          :src="logoUrl"
          :alt="companyName">
      </div>
      <div class="card-login">
        <h4>
          {{ $t('shirtigo.auth.headline') }}
        </h4>

        <div class="spacer-small"></div>

        <p>{{ $t('shirtigo.auth.description') }}</p>

        <div class="spacer-medium"></div>

        <div v-if="!formDataSent">

          <form class="login-form" @submit.prevent="submitForm">

            <form-group :has-danger="errors && errors.email">
              <float-label-input
                type="email"
                class-name="login-form__input input-lg"
                :title="$t('shirtigo.login.email_input_label')"
                :placeholder="''"
                :value="currentEmail"
                @input="onInput"
                :has-danger="errors && errors.email || Boolean(formError.email)"
                :autofocus="true"
                required
                :error-message="formError.email"
              />
            </form-group>

            <div>
              <sg-btn
                kind="primary"
                type="submit"
                class="btn-fullwidth"
                :loading="loginLoading">
                {{ $t('shirtigo.auth.primary_action') }}
              </sg-btn>
            </div>
          </form>
        </div>

        <div v-if="formDataSent">
          <p class="form-done">{{ $t('shirtigo.auth.email_sent') }}</p>
        </div>

      </div>
      <div class="spacer-medium"></div>
      <div class="login_create-account">
        <a :href="buildUrl('/login')" class="textlink text-weight-bold w-inline-block">
        <div>{{ $t('shirtigo.auth.secondary_action') }} </div>
        <div class="icon-xsmall w-embed">
          <svg xmlns="http://www.w3.org/2000/svg" id="V2" viewBox="0 0 24 24">
          <path fill="currentColor" d="m20.92,12.38c.1-.24.1-.52,0-.76-.05-.12-.12-.23-.22-.33l-7-7c-.39-.39-1.02-.39-1.41,0s-.39,1.02,0,1.41l5.29,5.29H4c-.55,0-1,.45-1,1s.45,1,1,1h13.59l-5.29,5.29c-.39.39-.39,1.02,0,1.41.2.2.45.29.71.29s.51-.1.71-.29l7-7c.09-.09.17-.2.22-.33Z"></path>
          </svg>
        </div>
        </a>
      </div>

    </div>
  </div>
</template>

<script>
  import SgBtn from 'sb/elements/Buttons/SgBtn.vue'
  import FloatLabelInput from 'sb/elements/Form/FloatLabelInput.vue'
  import FormGroup from 'sb/elements/Form/FormGroup.vue'

  export default {

    props: {
      formError: {
        type: [Object, String],
        default: () => ({}),
      },
      email: {
        type: String,
        default: ''
      },
      providerData: {
        type: Object,
        default: () => ({})
      },
      loginLoading: Boolean,
      formDataSent: {
        type: Boolean,
        default: false
      },
    },

    data() {
      return {
        errors: {},
        currentEmail: this.email,
      }
    },

    watch: {
      email(newValue) {
        this.currentEmail = newValue;
      }
    },

    computed: {
      logoUrl() {
        return (this.providerData && this.providerData.logo) || '/images/shirtigo-id-logo-color.svg'
      },
      companyName() {
        return (this.providerData && this.providerData.company_name) || 'Shirtigo ID'
      }
    },

    methods: {
      onInput(value) {
        this.currentEmail = value;
        this.$emit('input', this.currentEmail);
      },
      submitForm() {
        this.errors = {}

        if (this.currentEmail.length === 0) {
          this.$set(this.errors, 'email', true)
        }

        this.$emit('submit', { email: this.currentEmail })
      },
      buildUrl(path) {
        let url = new URL(path, location.origin)
        url.search = new URLSearchParams(location.search)
        return url
      }
    },

    components: {
      SgBtn,
      FloatLabelInput,
      FormGroup,
    },

  }
</script>

<style lang="scss" scoped>
  @import "~sb_sass/variables";
  @import "~sb_sass/mixins";

  .spacer-small {
    padding-top: $spacing-sm;
  }
  .spacer-medium {
    padding-top: $spacing-md;
  }

  .form-done {
    text-align: center;
    background-color: #ddd;
    padding: 20px;
  }

  .login-bg {
    min-height: 100vh;
    background-color: #f8fafc;
    justify-content: center;
    align-items: center;
    padding-left: 2.5rem;
    padding-right: 2.5rem;
    display: flex;
    .login_content-wrapper {
      flex-direction: column;
      align-items: center;
      min-width: 34rem;
      max-width: 34rem;
      margin-left: auto;
      margin-right: auto;
      display: flex;
      .login_logo {
        min-width: 13rem;
        max-width: 13rem;
        margin-bottom: 2.5rem;
        margin-top: 1.5rem;
        img {
          max-width: 100%;
          display: inline-block;
          vertical-align: middle;
        }
      }
      .card-login {
        padding: 3rem;
        border: 1px solid #e2e8f0;
        border-radius: 1rem;
        background-color: $white;
        width: 100%;
        position: relative;
        overflow: visible;
        box-shadow: 0 4px 16px -4px #102a811a;
        .forgot-your-password-text {
          margin-top: .5rem !important;
          margin-right: 0rem !important;
          margin-bottom: 0rem !important;
          margin-left: 0rem !important;
          a {
            color: $blue-90;
            text-decoration: none;
            font-size: 1rem;
            line-height: 1.6;
          }
        }
        h4 {
          color: #152340;
          font-size: 1.5rem;
          margin-top: 0;
          margin-bottom: 0;
          font-weight: 700;
          line-height: 1.4;
          text-align: center;
        }
      }
    }
    .login_create-account {
      grid-column-gap: .5rem;
      grid-row-gap: .5rem;
      flex-flow: wrap;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 1rem;
      line-height: 1.6;
      color: #334155;
      font-weight: 400;
      margin-bottom: 1.5rem;
      .textlink {
        grid-column-gap: .25rem;
        color: $blue-90;
        font-weight: 700;
        font-size: 1rem;
        line-height: 1.6;
        align-items: center;
        transition: all .15s;
        display: flex;
        &:hover {
          color: $blue-110;
        }
        .icon-xsmall {
          width: 1rem;
          height: 1rem;
          flex: none;
          justify-content: center;
          align-items: center;
          display: flex;
        }
      }
    }
  }

  @media screen and (max-width: 767px) {

    .login-bg {
      padding-left: 1rem;
      padding-right: 1rem;
      .login_content-wrapper {
        width: 100%;
        min-width: auto;
        .card-login {
          padding: 1.5rem;
          h4 {
            font-size: 1.25rem;
          }
          .btn {
            &.social {
              padding: .75rem 10px;
            }
          }
        }
      }
    }

  }
</style>
